import React from 'react';
import createForm from "../Form";
import ComponentField from "../../../form/ComponentField";
import DateTimeInput from "../../../form/DateTimeInput";
import Select from "../../../form/Select";

class LoyaltyPointExchangeRateForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="rate"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Árfolyam szorzó"
                            required={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("target_component")}
                            optionname="LoyaltyPointDiscountComponent"
                            storeType="local"
                            objectValue={false}
                            name="target_component"
                            value={this.props.values.target_component}
                            label="Célkomponens"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("start_date")}
                            isClearable={true}
                            maxDate={this.props.values.end_date}
                            name="start_date"
                            value={this.props.values.start_date}
                            label="Kezdés"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("end_date")}
                            isClearable={true}
                            minDate={this.props.values.start_date}
                            name="end_date"
                            value={this.props.values.end_date}
                            label="Vég"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LoyaltyPointExchangeRateForm);
